import(/* webpackMode: "eager" */ "/app/apps/press-cms/src/app/global-error.tsx");
